<template>
  <div class="users-avatars" v-if="users != null">
    <div class="text-avatars" v-if="!chatOpen">
      {{ users.length }} participant <span v-if="users.length > 1">(s) </span>
    </div>
    <div class="avatars">
      <li v-for="(user, index) in users" :key="index">
        <a class="avatars__item empty-image-user" v-if="index < userShowing">
              <chat-picture
                        :users="[
                           {
                                avatar_id: user.avatar_id,
                                avatar_color: user.avatar_color,
                              }
                            ,
                        ]"
                        :h="'24px'"
                        :w="'24px'"
                      />

        </a>
      </li>

       <div
        v-bind:class="!chatOpen ? 'user-dispo-open' : 'user-dispo-close'"
        v-if="users.length > userShowing"
      >
        +{{ users.length - userShowing }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'users-avartars',
  props: {
    users: Array,
    chatOpen: Boolean,
  },
  data() {
    return {
      userShowing: 10,
    }
  },
  computed: {
    has() {
      this.userShowing = !this.chatOpen ? 6 : 3
    },
  },
  mounted: function () {
    this.userShowing = !this.chatOpen ? 6 : 3
  },
  components: {
    ChatPicture: require('@/ui/ChatPicture').default,
  },
}
</script>

<style lang="scss">
@import "../../../static/scss/variables";

.users-avatars {
  display: flex;
  align-items: center;
  margin-left: 15px;
}

.text-avatars {
  margin-right: 15px;
  margin-left: 15px;
  font-size: 14px;
}

.user-dispo-close {
  color: #ffffff;
}

.user-dispo-open {
  color: red;
}
.avatars {
  align-items: center;
  color: white;
  display: flex;
  list-style-type: none;
  margin: auto;
  padding: 0px;
  flex-direction: row;
  &__item {
    border-radius: 100%;
    color: #ffffff;
    display: block;
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 100;
    height: 25px;
    width: 25px;
    line-height: 30px;
    text-align: center;
    transition: margin 0.1s ease-in-out;
    overflow: hidden;
    margin-left: -10px;
    text-decoration: none;

    &:first-child {
      z-index: 5;
    }
    &:nth-child(2) {
      z-index: 4;
    }
    &:nth-child(3) {
      z-index: 3;
    }
    &:nth-child(4) {
      z-index: 2;
    }
    &:nth-child(5) {
      z-index: 1;
    }
    &:last-child {
      z-index: 0;
    }
    img {
      width: 100%;
    }
  }
}
</style>
